export default "__VITE_ASSET__XU0tguXY__"